import {store} from "../stores/mainStore";

export const createHandName = config => {
	const {nameCont, handName, x, size, maxWidth, inScorecard} = config;
	const m = window.manager;
	const padding = 5;
	nameCont.removeAll(true);
	
	const textParts = store.getHandName(handName).split('*')
	const totalWidth = textParts.reduce((tot, str) => {
		let res;
		if(str.startsWith('suit')) {
			//res = m.scene.add.sprite(tot, 0.05*size, store.custom.dice + '_suits', str.charAt(str.length-1))
			res = m.scene.add.sprite(tot, 0.05*size, 'suits', str.charAt(str.length-1))
				.setOrigin(0, 0.5).setDisplaySize(54/57 *size , size); // 54x57 = size of suit pic
			m.diceInstances.add(res)
		} else {
			res = m.scene.add.text(tot, 0, str,
			{ 	font: '800 '+size+'px ' + m.ui.dodFontFamily,
				fill: '#ffffff', stroke: '#6e2411', strokeThickness: 2,
				shadow: { offsetX: 0, offsetY: 3, color: '#7d1b0080', blur: 0, stroke: false, fill: true }
			}).setOrigin(0, 0.5);
		}
		nameCont.add(res);
		return tot + res.displayWidth - 5;
	}, 0);
	const scale = Math.min(1, maxWidth / totalWidth);
	nameCont.setScale(scale);
	if(inScorecard) {
		const h = (size + 2*padding) / scale;
		var graphics = m.scene.add.graphics();
		graphics.fillStyle(0xa26325, 0.5);
		graphics.fillRoundedRect(-2*padding, -h/2, totalWidth + 4*padding, h, padding);
		nameCont.addAt(graphics, 0);
	} else {
		nameCont.setX(x - scale*totalWidth/2)
	}
	nameCont.config = config;
}
export const addHandName = (x, y, hand, size, maxWidth, inScorecard = false) => {
	const m = window.manager;
	const handName = hand.lastCombination === 0 ? '' : hand.lastCombination ? m.hands[hand.lastCombination] : hand;
	const nameCont = m.scene.add.container(x, y);

	createHandName({handName, x, nameCont, size, maxWidth, inScorecard})
	m.handNameInstances.add(nameCont);

	if(inScorecard && m.scoreCardContainer)
		m.scoreCardContainer.add(nameCont)
	return nameCont
}

export const shadowTextStyle = (weight=700, fs=65) => ({
	font: weight + ' ' + fs +'px ' + window.manager.ui.dodFontFamily,
	fill: '#ffffff',  stroke: '#ff0000', strokeThickness: 0,
	shadow: { offsetX: 0, offsetY: 3, color: '#00000059', blur: 0, stroke: false, fill: true }
})
export const strokeTextStyle = (weight, fs) => ({
	font: weight + ' ' + fs +'px ' + window.manager.ui.dodFontFamily,
	fill: '#ffffff', stroke: '#6e2411', strokeThickness: 3,
	shadow: { offsetX: 0, offsetY: 3, color: '#00000059', blur: 0, stroke: false, fill: true }
})
